import type { Transition } from "framer-motion";

/**
 * Repli d'un bloc de formulaire : hauteur et opacité sur la même course.
 *
 * Sans transition explicite, framer applique la sienne valeur par valeur — un
 * ressort pour les transformations, un fondu plus court pour le reste. Or
 * `AnimatePresence` ne démonte qu'une fois toutes les valeurs immobilisées : le
 * bloc restait planté là, déjà invisible, le temps qu'un ressort finisse de
 * s'éteindre, et la disparition semblait se faire en deux temps.
 *
 * Le bloc replié doit aussi contenir ses propres écarts — marges intérieures
 * plutôt que `padding` sur la boîte qui rétrécit —, faute de quoi ce qui n'est
 * pas animé survit à la hauteur et tombe d'un coup au démontage.
 */
export const COLLAPSE: Transition = { duration: 0.26, ease: [0.4, 0, 0.2, 1] };
